import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {MicroSentryErrorBusService, MicroSentryService} from '@micro-sentry/angular';
import {ApiResponse} from '../../api/api-response';

/**
 * Replaces the error handler shipped by micro-sentry to keep the expected authentication
 * errors out of Sentry, everything else is reported the same way.
 */
@Injectable({
  providedIn: 'root'
})
export class AppErrorHandler implements ErrorHandler {

  constructor(
    private errorBus: MicroSentryErrorBusService,
    microSentry: MicroSentryService
  ) {
    this.errorBus.errors$.subscribe((error) => {
      microSentry.report(<Error>error);
    });
  }

  handleError(error: any): void {
    console.error(error);

    // The session is over: the error interceptor already logged the user out and sent him back
    // to /login, reporting the 401 would only add noise to Sentry.
    if (this.isExpiredSession(error) || this.isExpiredSession(error?.rejection)) {
      return;
    }

    this.errorBus.next(error);
  }

  private isExpiredSession(error: any): boolean {
    if (error instanceof ApiResponse) {
      return error.getCode() === 401;
    }

    return error instanceof HttpErrorResponse && error.status === 401;
  }
}
